import { PatientFileData } from './types';

export type PatientFilesTypeAction =
  | FetchFilesAction
  | SetFilesFetchingAction
  | SetFilesAction
  | GenericPatientFileAction<'PATIENT_FILES_DELETE_FILE'>
  | GenericPatientFileAction<'PATIENT_FILES_APPROVE_FILE'>
  | GenericPatientFileAction<'PATIENT_FILES_RELEASE_FILE'>
  | GenericPatientFileAction<'PATIENT_FILES_UPDATE_FILE'>
  | GenericPatientFileAction<'PATIENT_FILES_ADD_FILE'>
  | GenericPatientFilesAction<'PATIENT_FILES_SET_FILES'>
  | GenericPatientFilesAction<'PATIENT_FILES_START_DELETING_FILES'>
  | GenericPatientFilesAction<'PATIENT_FILES_START_SENDING_FILES'>
  | GenericPatientFilesAction<'PATIENT_FILES_START_UPDATING_FILES'>;

export interface FetchFilesAction {
  type: 'PATIENT_FILES_FETCH';
  data: {
    patientId: string;
  };
}

export function fetchPatientFiles(patientId: string): FetchFilesAction {
  return {
    type: 'PATIENT_FILES_FETCH',
    data: { patientId },
  };
}

export interface SetFilesFetchingAction {
  type: 'PATIENT_FILES_SET_FILES_FETCHING';
  data: {
    patientId: string;
    fetching: boolean;
    error?: string;
  };
}

export function setFilesFetching(patientId: string, fetching: boolean, error?: string): SetFilesFetchingAction {
  return {
    type: 'PATIENT_FILES_SET_FILES_FETCHING',
    data: {
      patientId,
      fetching,
      error,
    },
  };
}

export interface SetFilesAction {
  type: 'PATIENT_FILES_SET_FILES';
  data: {
    patientId: string;
    files: PatientFileData[];
  };
}

export function setFiles(patientId: string, files: PatientFileData[]): SetFilesAction {
  return {
    type: 'PATIENT_FILES_SET_FILES',
    data: {
      patientId,
      files,
    },
  };
}

export interface GenericPatientFilesAction<T = any> {
  type: T;
  data: {
    patientId: string;
    files: PatientFileData[];
  };
}

export function deletePatientFiles(files: PatientFileData[], patientId: string): GenericPatientFilesAction<'PATIENT_FILES_START_DELETING_FILES'> {
  return {
    type: 'PATIENT_FILES_START_DELETING_FILES',
    data: {
      patientId,
      files,
    },
  };
}

export function releasePatientFiles(files: PatientFileData[], patientId: string): GenericPatientFilesAction<'PATIENT_FILES_START_RELEASING_FILES'> {
  return {
    type: 'PATIENT_FILES_START_RELEASING_FILES',
    data: {
      patientId,
      files,
    },
  };
}

export function approvePatientFiles(files: PatientFileData[], patientId: string): GenericPatientFilesAction<'PATIENT_FILES_START_SENDING_FILES'> {
  return {
    type: 'PATIENT_FILES_START_SENDING_FILES',
    data: {
      patientId,
      files,
    },
  };
}

export function updatePatientFiles(files: PatientFileData[], patientId: string): GenericPatientFilesAction<'PATIENT_FILES_START_UPDATING_FILES'> {
  return {
    type: 'PATIENT_FILES_START_UPDATING_FILES',
    data: {
      patientId,
      files,
    },
  };
}

export interface GenericPatientFileAction<T = any> {
  type: T;
  data: {
    patientId: string;
    file: PatientFileData;
  };
}

export function addPatientFile(patientId: string, file: PatientFileData): GenericPatientFileAction<'PATIENT_FILES_ADD_FILE'> {
  return {
    type: 'PATIENT_FILES_ADD_FILE',
    data: {
      patientId,
      file,
    },
  };
}

export function deletePatientFile(patientId: string, file: PatientFileData): GenericPatientFileAction<'PATIENT_FILES_DELETE_FILE'> {
  return {
    type: 'PATIENT_FILES_DELETE_FILE',
    data: {
      patientId,
      file,
    },
  };
}

export function releasePatientFile(patientId: string, file: PatientFileData): GenericPatientFileAction<'PATIENT_FILES_RELEASE_FILE'> {
  return {
    type: 'PATIENT_FILES_RELEASE_FILE',
    data: {
      patientId,
      file,
    },
  };
}

export function approvePatientFile(patientId: string, file: PatientFileData): GenericPatientFileAction<'PATIENT_FILES_APPROVE_FILE'> {
  return {
    type: 'PATIENT_FILES_APPROVE_FILE',
    data: {
      patientId,
      file,
    },
  };
}

export function updatePatientFile(patientId: string, file: PatientFileData): GenericPatientFileAction<'PATIENT_FILES_UPDATE_FILE'> {
  return {
    type: 'PATIENT_FILES_UPDATE_FILE',
    data: {
      patientId,
      file,
    },
  };
}
